type ApplicableTo = {
    lineOfBusiness: string[]; 
    quoteOutcome: string[]; 
    source: string[]; 
};

type AlertMessageConfig = {
    messages: string[]; 
    applicableTo: ApplicableTo; 
};


export const alertMessagesConfig: AlertMessageConfig[] = [
    {
        messages: ["Risk Details (including multi-class details if applicable)"],
        applicableTo: {
            lineOfBusiness: [],
            quoteOutcome: [],
            source: ["BIBERK", 
                "NICO", 
                "BHHC",
                "GEICO_SSP",
                "GEICO_ICLIQ",
                "HOMESITE",
                "HISCOX",
                "TRAVELERS",
                "ULTICA",
                "RYAN_SPECIALTY",
                "NEXT",
                "LIBERTY_MUTUAL",
                "HARTFORD",
                "NEXT"],
        },
    },
    {
        messages: [
            "Any Vehicle Customizations",
            "If Trucking, date of its first callback schedule",
        ],
        applicableTo: {
            lineOfBusiness: ["Commercial Auto", "Trucking"],
            quoteOutcome: ["Sale", "Follow-Up"],
            source: [],
        },
    },
    {
        messages: ["All types of Cargo"],
        applicableTo: {
            lineOfBusiness: ["General Liability",
                "Business Owner's Policy",
                "Worker's Compensation Policy",
                "Professional Liability",
                "Cyber Liability",
                "Bonds",
                "Inland Marine",
                "Cargo",
                "E&S",
                "Trucking",
                "Umbrella"
            ],
            quoteOutcome: ["Sale", "Follow-Up"],
            source: ["COVERWHALE"],
        },
    },
    {
        messages: [
            "All types of Cargo",
            "Brief Vehicle Usage",
            "Primary Business Details (other than the risk)",
            "Gross receipts of last & next year",
            "Largest city entered",
        ],
        applicableTo: {
            lineOfBusiness: ["General Liability",
                "Business Owner's Policy",
                "Worker's Compensation Policy",
                "Professional Liability",
                "Cyber Liability",
                "Bonds",
                "Inland Marine",
                "Cargo",
                "E&S",
                "Trucking",
                "Umbrella",
                "Commercial Auto"
            ],
            quoteOutcome: ["Sale", "Follow-Up"],
            source: ["NICO",
                     "BHHC"
            ],
        },
    },
    {
        messages: [
            "In connection with this application, we will use information about your credit history to develop a business owner insurance score, which is used for underwriting purposes for commercial insurance policies.",
        ],
        applicableTo: {
            lineOfBusiness: ["Commercial Auto"],
            quoteOutcome: ["Sale"],
            source: ["NICO",
                     "BHHC"
            ],
        },
    },
];
